import { Box, Typography, Stack, Tooltip, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { stripHtml } from "../CurriculumManagementAdmin/utils/html";
import { viewIconSx } from "../CurriculumManagementAdmin/components/buttonStyles";
import { BadgeChip } from "./components/AttendanceMarkers";

/**
 * One row per training the agent attended — not per curriculum — so a three-day curriculum shows
 * the three sessions they actually sat in, each carrying the badge it earned. Read-only: badges are
 * granted from the admin side. The curriculum it sits under and the date they attended live in the
 * details dialog rather than in columns, keeping the row to what identifies the training.
 */
export const getAttendedColumns = (onView) => [
	{
		field: "title",
		headerName: "Training",
		flex: 1.5,
		minWidth: 200,
		renderCell: (params) => (
			<Stack justifyContent="center" sx={{ height: "100%" }}>
				<Typography variant="body2" sx={{ fontWeight: 600 }} noWrap title={params.row.title}>
					{params.row.title}
				</Typography>
			</Stack>
		),
	},
	{
		// Widest column — the badge and action columns are fixed so the surplus lands here.
		field: "description",
		headerName: "Description",
		flex: 3,
		minWidth: 260,
		sortable: false,
		// Descriptions are rich text; the table shows the plain-text rendering of it.
		valueGetter: (value) => stripHtml(value),
		renderCell: (params) => (
			<Stack justifyContent="center" sx={{ height: "100%" }}>
				<Typography
					variant="body2"
					color="text.secondary"
					title={params.value}
					sx={{
						display: "-webkit-box",
						WebkitLineClamp: 2,
						WebkitBoxOrient: "vertical",
						overflow: "hidden",
						whiteSpace: "normal",
						lineHeight: 1.4,
					}}
				>
					{params.value || "—"}
				</Typography>
			</Stack>
		),
	},
	{
		field: "badge",
		headerName: "Badge Earned",
		width: 210,
		sortable: false,
		filterable: false,
		renderCell: (params) => (
			<Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
				<BadgeChip training={params.row} />
			</Box>
		),
	},
	{
		field: "actions",
		headerName: "Action",
		width: 110,
		sortable: false,
		filterable: false,
		headerAlign: "center",
		align: "center",
		renderCell: (params) => (
			<Stack justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
				<Tooltip title="View training details">
					<IconButton size="small" onClick={() => onView(params.row)} aria-label={`View ${params.row.title} details`} sx={viewIconSx}>
						<VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Tooltip>
			</Stack>
		),
	},
];
